'use client';

import { useMessagesToHostScript } from '@/hooks/useIframeMessages';
import { CaretDown } from '@phosphor-icons/react';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { Button } from './button';
function Header({
  replicaImage,
  replicaName,
  replicaDescription,
  className,
  ref
}: {
  replicaImage?: string;
  replicaName?: string;
  replicaDescription?: string | null;
  className?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
}) {
  const {
    handleClose
  } = useMessagesToHostScript();
  return <div ref={ref} className={twMerge('header-background backdrop-blur-[18px] py-[10px] px-4 sticky top-0 w-full z-10', className)} data-sentry-component="Header" data-sentry-source-file="header.tsx">
      <div className="flex items-center gap-2">
        {replicaImage && replicaName && <>
            <Image src={replicaImage as string} alt={replicaName as string} width={36} height={36} objectFit="contain" className="rounded-full shrink-0 h-10 w-10" />

            <div className="space-y-1">
              <p className="text-foreground font-semibold leading-none">{replicaName}</p>
              {replicaDescription && <p className="text-foreground/50 text-sm leading-none">{replicaDescription}</p>}
            </div>
          </>}

        <Button aria-label="Close Chat" variant="ghost" size="icon" onClick={handleClose} className="ml-auto" data-sentry-element="Button" data-sentry-source-file="header.tsx">
          <CaretDown size={20} weight="bold" className="fill-slate-900/30 group-hover:fill-slate-900" data-sentry-element="CaretDown" data-sentry-source-file="header.tsx" />
        </Button>
      </div>
    </div>;
}
export default Header;